<fui-icon [height]="20" [icon]="'drag-2x4'" [width]="20"></fui-icon>
